import React, { Component } from 'react';
import {
    avgDmarcAuthRateSelector,
    dmarcAuthIsLoadedSelector,
} from '../../selectors/dmarc-auth-selectors';
import {
    formattedEndDateSelector,
    formattedStartDateSelector
} from '../../selectors/reports-selectors';

import ProgressBulletGroup from '../../components/progress-bullet-group';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getDifferenceInRange } from '../../../utils/report-utils';

export class DmarcAuthProgressBulletsContainer extends Component{
    buildBulletMap = () => {
        const { startDate, endDate, rate } = this.props;
        const numberOfDays = getDifferenceInRange( startDate, endDate );

        return [
            { text: `Our average authentication rate over ${numberOfDays} days (between ${startDate} and ${endDate}) was ${rate}%.` },
            { text: 'Implementing (DMARC) blocking policies typically occurs after a 30-day average authentication rate is above 99%.' }
        ];
    }

    render(){
        const { isLoaded } = this.props;

        return (
            isLoaded &&
            <ProgressBulletGroup bullets={this.buildBulletMap()} />
        );
    }
};

/* istanbul ignore next */
const mapStateToProps = state => {
    return {
        endDate: formattedEndDateSelector( state ),
        isLoaded: dmarcAuthIsLoadedSelector( state ),
        rate: avgDmarcAuthRateSelector( state ),
        startDate: formattedStartDateSelector( state ),
    };
};

DmarcAuthProgressBulletsContainer.propTypes = {
    endDate: PropTypes.string.isRequired,
    isLoaded: PropTypes.bool.isRequired,
    rate: PropTypes.string.isRequired,
    startDate: PropTypes.string.isRequired,
};

export default connect( mapStateToProps )( DmarcAuthProgressBulletsContainer );
